

/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-27 15:27:59
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2024-11-28 11:55:33
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\lang\cn.js
 * @Description: 头部
 */
const page_header = {
  product: '产品',
  solution: '解决方案',
  learn: '学习',
  dev: '开发',
  contest: '大赛',
  about: '了解本源',
  chemiq: '生物化学',
  finance: '量子金融',
  educate: '量子教育',
  ai: '人工智能',
  bigData:'大数据',
  power:'电力行业',
  security: '信息安全',
  engineering: '工程设计',
  about_ori: '关于本源',
  union: '产业联盟',
  newslist: '新闻资讯',
  join: '加入本源',
  workbench: '工作台',
  login_register: '登录/注册',
  app_program: '量子计算编程开发工具包',
  app_learn: '量子机器学习开发工具包',
  publish_platform: '量子计算应用发布平台',
  dev_publish: '量子应用开发与发布平台',
  contest_form: '大赛平台',
  contest_platform: '量子计算开发者赛事平台',
  community: '开发者社区',
  learn_community: '量子计算学习分享社区',
  qhCloud: '量-超-云融合',
  profession: '行业解决方案',
  system: '系统解决方案',
  chip: '超导量子芯片测试表征系统解决方案',
  temperature: '超导量子计算机室温测控系统集成解决方案',
  computerServies: '计算服务',
  qvmText: '图形化编程',
  calculTask: '计算任务',
  applyTask: '应用中心',
  ideText: 'Cloud IDE',
  accountCenter: '账户设置',
  officialWebsite: '官方网站',
  originQCommunity: '本源社区',
  joinUs: '加入我们',
  language: '语言切换',
  logOut: '退出登录',
  noData: '暂无数据',
  noMessage: '暂无消息',
  more: '查看更多',
  messageCenter: '消息中心',
  expenseCenter: '费用中心',
  accessMag: '访问管理',
  computingResource: '算力资源',
  qApp: '量子应用',
  learnWeb: '本源溯知',
  paperAward: '卓越论文计划',
  service:'服务',
  service_quantum:'量子计算服务',
  service_lh:'融合计算服务',
  service_special: '专用量子云平台',
  tools:'编程工具',
  Qpanda:'QPanda',
  VQNet:'VQNet',
  pqypanda:'pyqpanda-algorithm',
  qrunes:'QRunes',
  qurator:'Qurator',
  learnSource:'学习资源',
  documentShow:'文档',
  website:'官方网站',
  home:'首页',
 
};
export default page_header;
